
  import { reactive } from "vue";
  import DynamicForm from "@/components/Shared/Dynamicform/DynamicForm.vue";
  
  export default {
    name: "UserActivation",
    inheritAttrs: false,
    components: {
      DynamicForm
    },
    setup() {
      const request = reactive({
        apiLoadMethod: "api/anonymousForm/loadForm",
        apiSaveMethod: "api/anonymousForm/saveForm",
        form: "RegistrierungBestaetigen",
        page: "RegistrierungBestaetigenDaten",
        remoteId: "",
        
        
      });
  
      return {
        request,
      };
    }
  };
  